import { render } from "./sdgdcgbd.vue?vue&type=template&id=41d5f8ee&ts=true"
import script from "./sdgdcgbd.vue?vue&type=script&lang=ts"
export * from "./sdgdcgbd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__